const EnvService = {

  apiBaseURL: process.env.VUE_APP_API_URL,
  appEnv: process.env.NODE_ENV,

  isDev: function () {
    return this.appEnv === 'development'
  },
  subDomain: () => {
    let matches = location.url.match(/^https?:\/\/([^.]+?)/)
    return matches ? matches[1] : null
  },
}


export default EnvService
